/** Session-scoped lock: covers optimistic upload before project status catches up. Cleared when ingest completes. */
const PREFIX = 'ensomirai-bootstrap-gate:';

export function lockBootstrapGate(projectId: string): void {
  if (!projectId || typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.setItem(`${PREFIX}${projectId}`, String(Date.now()));
  } catch {
    /* private mode / quota */
  }
}

export function clearBootstrapGateLock(projectId: string): void {
  if (!projectId || typeof sessionStorage === 'undefined') return;
  try {
    sessionStorage.removeItem(`${PREFIX}${projectId}`);
  } catch {
    /* ignore */
  }
}

export function isBootstrapGateLocked(projectId: string): boolean {
  if (!projectId || typeof sessionStorage === 'undefined') return false;
  try {
    return sessionStorage.getItem(`${PREFIX}${projectId}`) != null;
  } catch {
    return false;
  }
}
